/*
 *
 *  hdd 算量报价
 *
 */
import {
    Checkbox,
    Button,
    Collapse,
    Dropdown,
    Menu,
    Space,
    Tabs,
    Divider,
    Modal,
} from 'antd';
import { DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import IconChevronRight from '@/assets/svgicon/Icon-Chevron-Right.svg';
import IconRecovery from '@/assets/svgicon/Icon-Recovery.svg';
import IconRevocation from '@/assets/svgicon/Icon-Revocation.svg';
import ItemComponent from './ItemComponent';
import initData1 from './data';
import './index.scss';
import { useEffect } from 'react';

const { Panel } = Collapse;
console.log('hdd quantityTokeOff page initData', initData1);
export default function QuantityTokeOff() {
    const [step, setStep] = useState(0);
    const [activeKey, setActiveKey] = useState([]);
    const [detailData, setDetailData] = useState({});
    const [detailDataIndex, setDetailDataIndex] = useState(0);
    const [initData, setInitData] = useState({});
    const [tabActiveKey, setTabActiveKey] = useState('0');
    const [tabIndex, setTabIndex] = useState(0);
    const [quantityChecked, setQuantityChecked] = useState(true);
    const [buildingChecked, setBuildingChecked] = useState(true);
    const [syncOpen, setSyncOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [undoState, setUndoState] = useState('disabled');
    const [redoState, setRedoState] = useState('disabled');
    const [recoverRemove, setRecoverRemove] = useState(false);

    console.log('hdd quantityTokeOff page step', setStep);
    const formatData = data => {
        if (Object.keys(data).length === 0) return {};
        let mep = data.mep;
        mep.categoryList = Object.values(mep.category);
        let other = data.other;
        other.name = '其他';
        other.isOther = true;
        let rooms = data.rooms.map(item => {
            item.categoryList = Object.values(item.category);
            item.categoryList.forEach(cat => {
                if (cat.category) {
                    cat.categoryList = Object.values(cat.category);
                }
            });
            item.isOther = false;
            return item;
        });
        data.allType = rooms.concat(mep).concat(other);

        return data;
    };

    const PanelHeader = props => {
        const { info, index } = props;
        console.log('PanelHeader info', info);
        const onClickArrow = e => {
            e.stopPropagation();
            console.log('PanelHeader onClickArrow', index);
            if (activeKey.includes(index)) {
                setActiveKey(activeKey.filter(key => key !== index));
            } else {
                setActiveKey([...activeKey, index]);
            }
        };

        const onClickHeader = e => {
            e.stopPropagation();
            setStep(1);
            // setDetailData(info);
            setDetailDataIndex(index);
            console.log('PanelHeader onClickHeader', index, info);
        };

        return (
            <div onClick={onClickHeader} className="panel-header">
                <div className="header-left">
                    <span className="header-left-name">{info.name}</span>
                    <span className="header-left-area">
                        面积：{info.area?.toFixed(2)}m²
                    </span>
                </div>
                <div className="header-right">
                    <span className="header-right-price">¥ {info.price}</span>
                    {!info.isOther && (
                        <DownOutlined
                            onClick={onClickArrow}
                            className={`header-right-icon ${
                                activeKey.includes(index) ? 'active' : ''
                            }`}
                        />
                    )}
                </div>
            </div>
        );
    };

    const menu = (
        <Menu>
            {initData?.allType?.map((item, index) => (
                <Menu.Item
                    key={index}
                    onClick={() => {
                        // setDetailData(item);
                        setDetailDataIndex(index);
                    }}>
                    <div className="menu-item">
                        <span className="menu-item-name">{item.name}</span>
                    </div>
                </Menu.Item>
            ))}
        </Menu>
    );

    const onTabChange = key => {
        setTabActiveKey(key);
        console.log('Tab changed to:', key);
        const selectedCategory = detailData.categoryList?.[key];
        if (selectedCategory) {
            console.log('Selected Category:', selectedCategory);
        }
    };

    const handleClickSubCategory = (item, catIndex, panelIndex) => {
        setStep(1);
        // setDetailData(item);
        setDetailDataIndex(panelIndex);
        setTabActiveKey(catIndex.toString());
    };

    const onQuantityChange = e => {
        console.log('onQuantityChange', e.target.checked);
        setQuantityChecked(e.target.checked);
        // 处理水电按面积整体计算的逻辑
        let obj = {
            type: 1,
            value: e.target.checked,
        };
        try {
            console.log(
                'DispatchFun Quantity ModifyOption',
                JSON.stringify(obj)
            );
            console.log('API Name: ModifyOption');
            window.external.DispatchFun(
                'Quantity',
                'ModifyOption',
                JSON.stringify(obj)
            );
        } catch (error) {
            console.error('Error in onQuantityChange:', error);
        }
    };

    const onBuildingChange = e => {
        console.log('onBuildingChange', e.target.checked);
        setBuildingChecked(e.target.checked);
        // 处理不含拆建的逻辑
        let obj = {
            type: 2,
            value: e.target.checked,
        };
        console.log('DispatchFun Building ModifyOption', JSON.stringify(obj));
        console.log('API Name: ModifyOption');
        try {
            window.external.DispatchFun(
                'Quantity',
                'ModifyOption',
                JSON.stringify(obj)
            );
        } catch (error) {
            console.error('Error in onBuildingChange:', error);
        }
    };

    const onExport = () => {
        console.log('Exporting list...');
        // 处理导出清单的逻辑
        try {
            window.external.DispatchFun('Quantity', 'ExportExcel', '');
        } catch (error) {
            console.error('Error in onExport:', error);
        }
    };

    const onSync = () => {
        console.log('Syncing list...');
        // 处理同步清单的逻辑
        setSyncOpen(true);
    };

    const onSyncOk = () => {
        setLoading(true);
        console.log('Sync confirmed');
        // 处理同步清单的确认逻辑
        let params = {
            recover_remove: recoverRemove,
        };
        console.log('prams', params);
        try {
            setLoading(false);
            setSyncOpen(false);
            window.external.DispatchFun(
                'Quantity',
                'Sync',
                JSON.stringify(params)
            );
        } catch (error) {
            console.error('Error in onSync:', error);
        }
    };

    const timer = useState(null);
    const timer1 = useState(null);

    useEffect(() => {
        // 模拟数据格式化
        window.GetAllQuantityData = (data, undoOrRedoData) => {
            console.log('GetAllQuantityData: data', data);
            console.log('开始解析数据', typeof data === 'string');
            let hddData = typeof data === 'string' ? JSON.parse(data) : data;
            console.log('解析完成');
            const formattedData = formatData(hddData);
            console.log('Formatted Data:', formattedData);
            setQuantityChecked(formattedData.mep_by_area);
            setBuildingChecked(formattedData.exclude_break);
            if (undoOrRedoData) {
                console.log('undoOrRedoData:', undoOrRedoData);
                undoOrRedoData =
                    typeof undoOrRedoData === 'string'
                        ? JSON.parse(undoOrRedoData)
                        : undoOrRedoData;

                if (undoOrRedoData.type === 'project') {
                    setStep(0);
                    setInitData(formattedData);
                    return;
                }
                console.log('Parsed undoOrRedoData:', undoOrRedoData);
                let _index = 0;
                let _tabActiveKey = 0;
                let _tabIndex = 0;

                formattedData.allType.forEach((item, idx) => {
                    if (item.categoryList && item.categoryList.length !== 0) {
                        item.categoryList.forEach((cat, catIdx) => {
                            if (
                                cat.items &&
                                cat.items.length !== 0 &&
                                cat.items.some(
                                    subItem => subItem.id === undoOrRedoData.id
                                )
                            ) {
                                _index = idx;
                                _tabActiveKey = catIdx.toString();
                                _tabIndex = 0;
                            }

                            if (
                                cat.categoryList &&
                                cat.categoryList.length !== 0
                            ) {
                                cat.categoryList.forEach((subCat, subIdx) => {
                                    if (
                                        subCat.items &&
                                        subCat.items.length !== 0 &&
                                        subCat.items.some(
                                            subItem =>
                                                subItem.id === undoOrRedoData.id
                                        )
                                    ) {
                                        _index = idx;
                                        _tabActiveKey = catIdx.toString();
                                        _tabIndex = subIdx;
                                    }
                                });
                            } else {
                                if (
                                    cat.items &&
                                    cat.items.length !== 0 &&
                                    cat.items.some(
                                        subItem =>
                                            subItem.id === undoOrRedoData.id
                                    )
                                ) {
                                    _index = idx;
                                    _tabActiveKey = catIdx.toString();
                                    _tabIndex = 0;
                                }
                            }
                        });
                    }
                    if (
                        item.items &&
                        item.items.length !== 0 &&
                        item.items.some(
                            subItem => subItem.id === undoOrRedoData.id
                        )
                    ) {
                        _index = idx;
                        _tabActiveKey = '0';
                        _tabIndex = 0;
                    }
                });

                clearTimeout(timer.current);
                clearTimeout(timer1.current);
                console.log('Setting detailDataIndex:', _index);
                console.log('Setting tabActiveKey:', _tabActiveKey);
                console.log('Setting tabIndex:', _tabIndex);
                setDetailDataIndex(_index);
                setTabActiveKey(_tabActiveKey);
                setTabIndex(_tabIndex);
                setStep(1);
                timer.current = setTimeout(() => {
                    setInitData(formattedData);
                }, 0);
                timer1.current = setTimeout(() => {
                    let items = document.querySelector(
                        `.id-${undoOrRedoData.id}`
                    );
                    console.log('items', items);
                    if (items) {
                        items.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 400);
            } else {
                setInitData(formattedData);
                console.log('Formatted Data:', formattedData);
            }
        };

        if (
            window.location.hostname === 'localhost' /* ||
            window.location.hostname === '10.110.4.102' */
        ) {
            // 如果是在本地开发环境，使用模拟数据
            window.GetAllQuantityData(initData1, {
                id: 'A0F08F7A-3FB0-4991-CBDC-A0D079D2E521',
            });
        }

        window.SetRedoState = state => {
            console.log('SetRedoState:', state);
            // 处理撤销和恢复的状态
            setRedoState(+state === 1 ? 'enabled' : 'disabled');
        };

        window.SetUndoState = state => {
            console.log('setUndoState:', state);
            // 处理撤销和恢复的状态
            setUndoState(+state === 1 ? 'enabled' : 'disabled');
        };
    }, []);

    useEffect(() => {
        console.log('initData changed:', initData, detailDataIndex);
        if (initData?.allType?.length > 0) {
            setDetailData(initData.allType[detailDataIndex]);
        }
    }, [initData, detailDataIndex]);

    const handleUndo = () => {
        console.log('Undo action triggered');
        // 处理撤销操作
        try {
            window.external.DispatchFun('Quantity', 'Undo', '');
        } catch (error) {
            console.error('Error in handleUndo:', error);
        }
    };

    const handleRedo = () => {
        console.log('Redo action triggered');
        // 处理恢复操作
        try {
            window.external.DispatchFun('Quantity', 'Redo', '');
        } catch (error) {
            console.error('Error in handleRedo:', error);
        }
    };

    const domMap = {
        0: (
            <div className="hdd-quantity-toke-off-step1">
                <div className="title-redo-undo">
                    <div
                        className={
                            'btn-action ' +
                            (undoState === 'disabled' ? ' disabled' : '')
                        }
                        onClick={handleUndo}>
                        <img src={IconRevocation} alt="" />
                        撤销
                    </div>
                    <div
                        className={
                            'btn-action ' +
                            (redoState === 'disabled' ? ' disabled' : '')
                        }
                        onClick={handleRedo}>
                        <img src={IconRecovery} alt="" />
                        恢复
                    </div>
                </div>
                <div className="title">
                    <div className="title-left">
                        <img
                            src={
                                initData.thumbnail ||
                                'https://img.yzcdn.cn/vant/cat.jpeg'
                            }
                            alt=""
                        />
                        <div className="title-info">
                            <span className="name">{initData.name}</span>
                            <span className="area">
                                建筑面积：{initData.area?.toFixed(2)}{' '}
                                m²&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;层高：
                                {initData.floor_height} m
                            </span>
                        </div>
                    </div>
                    <div className="title-right">
                        <div className="title-info">
                            <span className="price-label">装修总价</span>
                            <span className="price">¥ {initData.price}</span>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <Collapse bordered={false} activeKey={activeKey}>
                        {initData?.allType?.map((item, index) => (
                            <Panel
                                showArrow={false}
                                header={
                                    <PanelHeader info={item} index={index} />
                                }
                                key={index}>
                                {item.categoryList &&
                                    item.categoryList.map((cat, catIndex) => (
                                        <div
                                            className="panel-content"
                                            key={catIndex}
                                            onClick={() =>
                                                handleClickSubCategory(
                                                    item,
                                                    catIndex,
                                                    index
                                                )
                                            }>
                                            <div className="panel-content-left">
                                                <span className="panel-content-left-label">
                                                    {cat.name}
                                                </span>
                                                <span className="panel-content-left-price">
                                                    ¥ {cat.price}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                            </Panel>
                        ))}
                    </Collapse>
                </div>
            </div>
        ),
        1: (
            <div className="hdd-quantity-toke-off-step2">
                <div className="title">
                    <div className="title-left">
                        <div className="btn" onClick={() => setStep(0)}>
                            <img src={IconChevronRight} />
                            返回
                        </div>
                        <Dropdown overlay={menu} trigger={['click']}>
                            <Space>
                                {detailData.name || '请选择类型'}
                                <Divider
                                    type="vertical"
                                    style={{ color: '#000' }}
                                />
                                <span>
                                    ¥ {detailData.price?.toFixed(2) || ''}
                                </span>
                                <DownOutlined />
                            </Space>
                        </Dropdown>
                    </div>
                    <div className="title-right">
                        <div
                            className={
                                'btn-action ' +
                                (undoState === 'disabled' ? ' disabled' : '')
                            }
                            onClick={handleUndo}>
                            <img src={IconRevocation} alt="" />
                            撤销
                        </div>
                        <div
                            className={
                                'btn-action ' +
                                (redoState === 'disabled' ? ' disabled' : '')
                            }
                            onClick={handleRedo}>
                            <img src={IconRecovery} alt="" />
                            恢复
                        </div>
                    </div>
                </div>
                <div
                    className={`content ${
                        detailData?.categoryList?.length > 1
                            ? 'has-tabs'
                            : 'no-tabs'
                    }`}>
                    {detailData?.categoryList?.length > 0 && (
                        <Tabs
                            centered
                            onChange={key => onTabChange(key)}
                            activeKey={tabActiveKey}>
                            {detailData?.categoryList?.map((cat, index) => (
                                <Tabs.TabPane
                                    tab={
                                        index !== +tabActiveKey ? (
                                            cat.name
                                        ) : (
                                            <>
                                                {cat.name} | ¥{' '}
                                                {cat.price?.toFixed(2) ||
                                                    '0.00'}
                                            </>
                                        )
                                    }
                                    key={index}>
                                    {!cat.categoryList && (
                                        <div
                                            style={{ padding: '10PX 0' }}></div>
                                    )}
                                    <div
                                        className={`tab-content ${
                                            cat.categoryList
                                                ? 'tab-content-has-category-list'
                                                : ''
                                        }`}>
                                        {cat.items ? (
                                            cat.items.map((item, idx) => (
                                                <ItemComponent
                                                    key={idx}
                                                    item={item}
                                                />
                                            ))
                                        ) : (
                                            <>
                                                <div className="vertical-tab">
                                                    <div className="vertical-tab-title">
                                                        {cat.categoryList &&
                                                            cat.categoryList.map(
                                                                (
                                                                    subCat,
                                                                    subIdx
                                                                ) => (
                                                                    <div
                                                                        key={
                                                                            subIdx
                                                                        }
                                                                        className={`vertical-tab-item ${
                                                                            tabIndex ===
                                                                            subIdx
                                                                                ? 'active'
                                                                                : ''
                                                                        }`}
                                                                        onClick={() => {
                                                                            setTabIndex(
                                                                                subIdx
                                                                            );
                                                                        }}>
                                                                        <span className="vertical-tab-item-name">
                                                                            {
                                                                                subCat.name
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                )
                                                            )}
                                                    </div>
                                                    <div className="vertical-tab-content">
                                                        {cat.categoryList &&
                                                            cat.categoryList[
                                                                tabIndex
                                                            ]?.items.map(
                                                                (
                                                                    item,
                                                                    itemIdx
                                                                ) => (
                                                                    <ItemComponent
                                                                        key={
                                                                            itemIdx
                                                                        }
                                                                        item={
                                                                            item
                                                                        }
                                                                        showImg={
                                                                            false
                                                                        }
                                                                    />
                                                                )
                                                            )}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </Tabs.TabPane>
                            ))}
                        </Tabs>
                    )}
                    {!detailData?.categoryList && (
                        <div className="no-tab-container">
                            {detailData.items &&
                                detailData.items.map((item, idx) => (
                                    <ItemComponent key={idx} item={item} />
                                ))}
                        </div>
                    )}
                </div>
            </div>
        ),
    };

    return (
        <div className="hdd-quantity-toke-off">
            {domMap[step]}
            {step === 0 && (
                <div className="footer">
                    <div className="left">
                        <Checkbox
                            checked={quantityChecked}
                            onChange={onQuantityChange}>
                            水电按面积整体计算
                        </Checkbox>
                        <Checkbox
                            checked={buildingChecked}
                            onChange={onBuildingChange}>
                            不含拆建
                        </Checkbox>
                    </div>
                    <div className="right">
                        <Button onClick={onExport}>导出清单</Button>
                        <Button onClick={onSync}>同步清单</Button>
                    </div>
                </div>
            )}

            <Modal
                title="提示"
                visible={syncOpen}
                onOk={onSyncOk}
                onCancel={() => setSyncOpen(false)}
                okText="确认"
                cancelText="取消"
                width={369}
                getContainer={() =>
                    document.querySelector('.hdd-quantity-toke-off')
                }
                footer={[
                    <Checkbox
                        key="checkbox"
                        checked={recoverRemove}
                        onChange={e => {
                            setRecoverRemove(e.target.checked);
                        }}>
                        恢复移除项
                    </Checkbox>,
                    <Button
                        key="submit"
                        className="confirm-btn"
                        loading={loading}
                        onClick={onSyncOk}>
                        确定
                    </Button>,
                    <Button key="back" onClick={() => setSyncOpen(false)}>
                        取消
                    </Button>,
                ]}>
                <div className="sync-modal-content">
                    <ExclamationCircleOutlined
                        style={{
                            color: '#FFD225',
                            fontSize: '24px',
                            marginRight: '8px',
                        }}
                    />
                    <div>
                        <p className="title">确认要同步清单吗？</p>
                        <p className="sub-title">
                            同步清单会根据最新的装修设计方案重新生成报价，原清单信息将被覆盖，
                            可下载当前清单后同步
                        </p>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
